/*
 *   File : risk-profiling.js.js
 *   Author : https://evoqins.com
 *   Description : User Risk score creating page
 *   Integrations : 
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// Components
import { Step1 } from './index';
import { Loader } from '../../Component/Others';
import { APIService } from '../../Service';
import { _scrollToTop } from '../../Helper';

function RiskProfiling(props) {

    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [riskQuestions, setRiskQuestions] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();

        setDataLoading(true);
        _getRiskProfile();
    }, []);

    // handle update step
    const _handleUpdateStep = (step) => {
        setCurrentStep(step);
        // Scroll the page to top
        _scrollToTop();
    };

    // handle Back
    const _handleBack = () => {
        if (currentStep === 1) {
            navigate("summary")
        } else {
            setCurrentStep(currentStep - 1);
        }
    };


    // ================================================== //
    // ============ RISK PROFILE API CALLS ============== //
    const _getRiskProfile = async () => {
        let url = "profile/get-questions";
        let data = {
            "tenant_id": props.tenantID
        };
        const response = await APIService(url, data);

        if (response.status_code === 200) {
            setRiskQuestions(response.data);
        } else {
            toast.dismiss();
            toast.error("Something went wrong please try again after some time");
            navigate(-1);
        }
        setDataLoading(false);
    };

    return (
        dataLoading ?
            <Loader wrapperClassName="h-100 margin-100px-top w-100" />
            :
            <div className='mb-5'>
                <Step1 questions={riskQuestions}
                    strategyID={props.strategyID}
                    userID={props.userID}
                    tenantID={props.tenantID}
                    basketName={props.basketName}
                    basketRiskInfo={props.basketRiskInfo}
                    handleUpdateStep={_handleUpdateStep}
                    handleOnSuccess={props.handleOnSuccess} />
            </div>
    )
}

export default RiskProfiling;